import { render, staticRenderFns } from "./AddTeacherAssessment.vue?vue&type=template&id=0451e710&scoped=true"
import script from "./AddTeacherAssessment.vue?vue&type=script&lang=js"
export * from "./AddTeacherAssessment.vue?vue&type=script&lang=js"
import style0 from "./AddTeacherAssessment.vue?vue&type=style&index=0&id=0451e710&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0451e710",
  null
  
)

export default component.exports